<template>
  <div class="pin-wrap g-ln-wrap" :style="{padding: padding}">
    <div class="pin-left" :style="{width: leftWidth, 'z-index': leftIndex}">
      <slot name="left"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LnLayout',
  props: {
    leftWidth: {
      type: String,
      default: '180px'
    },
    leftIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    padding () {
      return '0 0 0 ' + this.leftWidth
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LnLayout.vue